import { render, staticRenderFns } from "./GeneratedRecord.vue?vue&type=template&id=804e502c&scoped=true&"
import script from "./GeneratedRecord.vue?vue&type=script&lang=js&"
export * from "./GeneratedRecord.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedRecord.vue?vue&type=style&index=0&id=804e502c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e502c",
  null
  
)

export default component.exports